import { render, staticRenderFns } from "./issued-reserved-form.vue?vue&type=template&id=baa07176"
import script from "./issued-reserved-form.vue?vue&type=script&lang=js"
export * from "./issued-reserved-form.vue?vue&type=script&lang=js"
import style0 from "./issued-reserved-form.vue?vue&type=style&index=0&id=baa07176&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports